/* Скрипты секции resin-calculator, вынесенные из инлайна в кэшируемый ассет.
   Обёртка DOMContentLoaded заменена на проверку readyState, чтобы код
   отрабатывал и при отложенной вставке секции. */
(function () {
  function init() {
    const RESIN_DENSITY = 1.15;
    const RESERVE_FACTOR = 1.1;

    let activeShape = 'square';

    function norm(v) {
      return parseFloat(String(v).replace(',', '.'));
    }

    function valid(v) {
      return typeof v === 'number' && !isNaN(v) && v > 0;
    }

    function getRequiredKgSquare(w, l, h) {
      const volumeCm3 = (w * l * h) / 1000;
      const grams = volumeCm3 * RESIN_DENSITY * RESERVE_FACTOR;
      return grams / 1000;
    }

    function getRequiredKgCylinder(d, h) {
      const r = d / 2;
      const volumeCm3 = (Math.PI * r * r * h) / 1000;
      const grams = volumeCm3 * RESIN_DENSITY * RESERVE_FACTOR;
      return grams / 1000;
    }

    function formatWeight(kg) {
      if (kg < 0.01) {
        return Math.round(kg * 1000) + ' g';
      }
      return kg.toFixed(2) + ' kg';
    }

    function findBestProduct(selectedType) {
      const products = Array.from(document.querySelectorAll('#resin-product-feed .resin-product'));

      const typeNorm = selectedType.trim().toLowerCase();

      return (
        products
          .map((el) => {
            const types = el.dataset.types.split('||').map((t) => t.trim().toLowerCase());

            if (!types.includes(typeNorm)) return null;

            return {
              handle: el.dataset.handle,
            };
          })
          .filter(Boolean)[0] || null
      );
    }

    const hiddenCardsContainer = document.getElementById('resin-product-cards');
    const resultContainer = document.getElementById('resin-result');

    const desktopSlot = document.querySelector('.resin-right');
    const mobileSlot = document.querySelector('.result-mobile');

    let currentCard = null;

    function moveResultContainer() {
      if (!resultContainer) return;

      if (window.matchMedia('(max-width: 768px)').matches) {
        if (mobileSlot && !mobileSlot.contains(resultContainer)) {
          mobileSlot.appendChild(resultContainer);
        }
      } else {
        if (desktopSlot && !desktopSlot.contains(resultContainer)) {
          desktopSlot.appendChild(resultContainer);
        }
      }
    }

    window.addEventListener('resize', moveResultContainer);
    moveResultContainer();

    function renderProductByHandle(handle) {
      const source = hiddenCardsContainer.querySelector(`.resin-product-card[data-handle="${handle}"]`);

      if (!source || !resultContainer) return;

      if (currentCard) {
        hiddenCardsContainer.appendChild(currentCard);
      }

      resultContainer.innerHTML = '';
      resultContainer.appendChild(source);

      const recommendLabel = document.querySelector('.resin-recommend');

      requestAnimationFrame(() => {
        resultContainer.classList.add('is-active');

        if (recommendLabel) {
          recommendLabel.classList.add('is-active');
        }
      });

      currentCard = source;
      moveResultContainer();

      if (window.matchMedia('(max-width: 768px)').matches) {
        setTimeout(() => {
          const headerOffset = 120;
          const elementPosition = resultContainer.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }, 150);
      }
    }

    const widthInput = document.getElementById('r-width');
    const lengthInput = document.getElementById('r-length');
    const heightInput = document.getElementById('r-height');

    const diameterInput = document.getElementById('r-diameter');
    const cylHeightInput = document.getElementById('r-cylinder-height');

    const outError = document.getElementById('r-error');
    const outWeight = document.getElementById('r-weight');

    document.querySelectorAll('.shape-tab').forEach((btn) => {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.shape-tab').forEach((b) => b.classList.remove('is-active'));
        this.classList.add('is-active');

        activeShape = this.dataset.shape;

        document.querySelector('.square-dimensions').classList.toggle('is-active', activeShape === 'square');
        document.querySelector('.cylinder-dimensions').classList.toggle('is-active', activeShape === 'cylinder');
      });
    });

    [widthInput, lengthInput, heightInput, diameterInput, cylHeightInput].forEach((input) => {
      input.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9.,]/g, '');
      });
    });

    document.getElementById('r-reset').addEventListener('click', function () {
      widthInput.value = '';
      lengthInput.value = '';
      heightInput.value = '';

      diameterInput.value = '';
      cylHeightInput.value = '';

      outError.innerText = '';
      outWeight.innerText = '';

      if (currentCard) {
        hiddenCardsContainer.appendChild(currentCard);
        currentCard = null;
      }

      resultContainer.innerHTML = '';
      resultContainer.classList.remove('is-active');

      const recommendLabel = document.querySelector('.resin-recommend');
      if (recommendLabel) {
        recommendLabel.classList.remove('is-active');
      }
    });

    document.getElementById('r-calc').addEventListener('click', function () {
      outError.innerText = '';
      outWeight.innerText = '';

      let requiredKg = 0;

      if (activeShape === 'square') {
        const w = norm(widthInput.value);
        const l = norm(lengthInput.value);
        const h = norm(heightInput.value);

        if (!valid(w) || !valid(l) || !valid(h)) {
          outError.innerText = 'Enter valid numeric dimensions in mm.';
          return;
        }

        requiredKg = getRequiredKgSquare(w, l, h);
      } else {
        const d = norm(diameterInput.value);
        const h = norm(cylHeightInput.value);

        if (!valid(d) || !valid(h)) {
          outError.innerText = 'Enter valid numeric dimensions in mm.';
          return;
        }

        requiredKg = getRequiredKgCylinder(d, h);
      }

      outWeight.innerText = 'Resin Weight: ' + formatWeight(requiredKg);

      const selected = document.querySelector('input[name="r-type"]:checked');
      if (!selected) {
        outError.innerText = 'Please select a resin application type.';
        return;
      }

      const bestProduct = findBestProduct(selected.value);

      if (!bestProduct) {
        outError.innerText = 'No suitable product found for this volume.';
        return;
      }

      renderProductByHandle(bestProduct.handle);

      // Активировать подходящий вариант после рендера карточки
      setTimeout(() => {
        activateBestVariantForWeight(requiredKg);
      }, 100);
    });

    // Функция для активации подходящего варианта на основе расчитанного веса
    function activateBestVariantForWeight(requiredKg) {
      const calculatorCard = document.querySelector('#resin-result .grid__item-collection');
      if (!calculatorCard) return;

      const variants = calculatorCard.querySelectorAll('.variant-input-collection');
      if (!variants.length) return;

      // Собираем все варианты с весами
      const variantsWithWeights = [];
      variants.forEach(variantDiv => {
        const label = variantDiv.querySelector('label')?.textContent?.trim();
        const radioInput = variantDiv.querySelector('input[type="radio"]');
        if (!label || !radioInput) return;

        let variantWeightKg = 0;

        // Парсим вес: поддержка "150 g", "2.7 kg", "5 kg" и т.д.
        const kgMatch = label.match(/([\d.,]+)\s*kg/i);
        const gMatch = label.match(/([\d.,]+)\s*g(?!\w)/i);

        if (kgMatch) {
          variantWeightKg = parseFloat(kgMatch[1].replace(',', '.'));
        } else if (gMatch) {
          variantWeightKg = parseFloat(gMatch[1].replace(',', '.')) / 1000;
        } else {
          return;
        }

        variantsWithWeights.push({
          element: variantDiv,
          radioInput: radioInput,
          weight: variantWeightKg,
          isAvailable: !radioInput.disabled
        });
      });

      if (!variantsWithWeights.length) return;

      // Сортируем варианты по весу (по возрастанию)
      variantsWithWeights.sort((a, b) => a.weight - b.weight);

      let bestVariant = null;

      // Ищем первый доступный вариант >= requiredKg
      for (let i = 0; i < variantsWithWeights.length; i++) {
        const variant = variantsWithWeights[i];
        if (variant.weight >= requiredKg && variant.isAvailable) {
          bestVariant = variant;
          break;
        }
      }

      // Если не нашли доступный >= requiredKg, ищем максимальный доступный < requiredKg
      if (!bestVariant) {
        for (let i = variantsWithWeights.length - 1; i >= 0; i--) {
          const variant = variantsWithWeights[i];
          if (variant.isAvailable) {
            bestVariant = variant;
            break;
          }
        }
      }

      // Активировать найденный вариант
      if (bestVariant && bestVariant.radioInput) {
        bestVariant.radioInput.checked = true;
        bestVariant.radioInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function init() {
    const tooltipBtn = document.querySelector('.resin-tooltip-wrapper');
    if (!tooltipBtn) return;

    tooltipBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      tooltipBtn.classList.toggle('is-open');
    });

    document.addEventListener('click', function () {
      tooltipBtn.classList.remove('is-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
